import React, { memo } from 'react';
import s from './MiniResultStatus.scss';
import StatusCardTitle from '../StatusCardTitle';

const markHighest = data => {
  let highestlsws = 0;
  let highestIndices = [];

  // Single loop to find the highest lsws and collect all indices with this value
  if (data && Array.isArray(data) && data.length > 0) {
    data.forEach((item, index) => {
      if (item.ls + item.ws > highestlsws) {
        highestlsws = item.ls + item.ws;
        highestIndices = [index];
      } else if (item.ls + item.ws === highestlsws) {
        highestIndices.push(index);
      }
    });
  }

  // Mark only the highest, which can be only one as asked
  if (highestIndices.length > 0 && highestlsws > 0) {
    data[highestIndices[0]].highest = true;
  }
};

const MiniResultStatus = ({
  parties,
  isExitPoll,
  noBorder,
  borderBtm,
  name,
  path,
  infoMsg,
  activeSeats,
  colorMap,
  cntCntr,
  totalSeats,
  source,
}) => {
  let ws_ls =
    !isExitPoll && parties && Array.isArray(parties) && parties.length > 0
      ? parties.reduce((acc, party) => {
          acc += party.ws + party.ls;
          return acc;
        }, 0)
      : 0;
  if (isNaN(ws_ls)) {
    ws_ls = 0;
  }
  let ws =
    !isExitPoll && parties && Array.isArray(parties) && parties.length > 0
      ? parties.reduce((acc, party) => {
          acc += party.ws;
          return acc;
        }, 0)
      : 0;

  if (isNaN(ws)) {
    ws = 0;
  }

  if (!isExitPoll) {
    markHighest(parties);
  }

  return (
    <div
      className={`
      ${s.miniResultWrap}
      ${noBorder ? s.noBrdr : ''}
      ${borderBtm ? s.brdrBtm : ''}
      ${cntCntr ? s.contentCenter : ''}
    `}
    >
      {name &&
        path && (
          <StatusCardTitle
            name={name}
            path={path}
            infoMsg={path && name && infoMsg ? infoMsg : ''}
            activeSeats={path && name && activeSeats ? activeSeats : ''}
            smallSize
            isExitPoll={isExitPoll}
            ws_ls={ws_ls}
            ws={ws}
            totalSeats={totalSeats}
          />
        )}
      <div className={`${s.partyRow}`}>
        {parties &&
          Array.isArray(parties) &&
          parties.length > 0 &&
          parties.map(party => (
            <div
              className={`${s.partyCol} ${party.highest ? s.selected : null}`}
            >
              <div
                className={s.partyColCell}
                style={(() => {
                  if (!isExitPoll && party.highest) {
                    return {
                      backgroundColor:
                        party.color || colorMap?.[party.nm]?.cc || '#84898B',
                    };
                  }
                  return {
                    color: party.color || colorMap?.[party.nm]?.cc || '#84898B',
                  };
                })()}
              >
                <span
                  style={(() => {
                    if (!isExitPoll && party.highest) {
                      return null;
                    }
                    return {
                      color:
                        party.color || colorMap?.[party.nm]?.cc || '#84898B',
                    };
                  })()}
                >
                  {party.an || party.nm}
                </span>

                <p
                  style={(() => {
                    if (!isExitPoll && party.highest) {
                      return null;
                    }
                    return {
                      color:
                        party.color || colorMap?.[party.nm]?.cc || '#84898B',
                    };
                  })()}
                >
                  {(() => {
                    if (isExitPoll) {
                      if (party.ls === party.wsc) {
                        return <>{isNaN(party.ls) ? 0 : party.ls}</>;
                      }
                      return (
                        <>
                          {isNaN(party.ls) ? 0 : party.ls}-{isNaN(party.wsc)
                            ? 0
                            : party.wsc}
                        </>
                      );
                    }
                    return (
                      <>
                        {Number(isNaN(party.ls) ? 0 : party.ls) +
                          Number(isNaN(party.ws) ? 0 : party.ws)}
                      </>
                    );
                  })()}
                </p>
              </div>
            </div>
          ))}
        {parties &&
          Array.isArray(parties) &&
          parties.length === 0 &&
          isExitPoll && (
            <div className={s.noData}>
              No data break up is given{' '}
              {source?.name ? `by ${source?.name} ` : ''}for the state
            </div>
          )}
      </div>
    </div>
  );
};

export default memo(MiniResultStatus);
